// @ts-check

/**
 * Changes a hex value with opacity to rgba
 * @param {string} hex - color represented in HEX code.
 * @param {string} opacity - the opacity to use in rgba.
 * @return {string} rgba - rgba value.
 */
const hexToRGBA = (hex, opacity) => {
  hex = hex.replace('#', '');

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export default hexToRGBA